import { jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import { useLocation } from 'react-router-dom';
import { BabylonActions } from '../reactBabylonLink';
import styles from './StableArrows.module.scss';
export const StableArrows = ({ isLocked }) => {
    const { pathname } = useLocation();
    const isHorse = pathname.includes('/horse');
    const isJockey = pathname.includes('/jockey');
    const onLeftArrowClick = () => {
        if (isHorse || isJockey) {
            BabylonActions.StablesNextStall();
        }
    };
    const onRightArrowClick = () => {
        if (isHorse || isJockey) {
            BabylonActions.StablesPrevStall();
        }
    };
    const disabledStyle = {
        opacity: isLocked || !(isHorse || isJockey) ? 0.0 : 1,
        pointerEvents: isLocked || !(isHorse || isJockey) ? 'none !important' : 'initial'
    };
    return (_jsxs(Box, Object.assign({ component: "div", className: styles.arrowWrapper }, { children: [_jsxs(Box, Object.assign({ component: "a", href: "#", className: styles.stableArrow, sx: Object.assign({ left: '16px' }, disabledStyle), onPointerDown: onLeftArrowClick }, { children: [' ', "\u276E", ' '] })), _jsxs(Box, Object.assign({ component: "a", href: "#", className: styles.stableArrow, sx: Object.assign({ right: '16px' }, disabledStyle), onPointerDown: onRightArrowClick }, { children: [' ', "\u276F", ' '] }))] })));
};
